export default "__VITE_ASSET__CJZIUV7k__"